import { render, staticRenderFns } from "./Suministros.vue?vue&type=template&id=49e87eb8&scoped=true"
import script from "./Suministros.vue?vue&type=script&lang=js"
export * from "./Suministros.vue?vue&type=script&lang=js"
import style0 from "./Suministros.vue?vue&type=style&index=0&id=49e87eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e87eb8",
  null
  
)

export default component.exports